import { createLoader } from "nuqs";

import { dispatchParsers, teleopParsers } from "./parsers";

// LOADERS
export const dispatchLoader = createLoader(dispatchParsers);
export const teleopLoader = createLoader(teleopParsers);
